var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('div',{ref:"google_one_tap"})])
}
var staticRenderFns = []

export { render, staticRenderFns }